module.exports = __webpack_public_path__ + "geomanist-regular-webfont.deb2e275f84cb3a34faa.woff";


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/assets/fonts/geomanist/geomanist-regular-webfont.woff
// module id = ../../../../../src/assets/fonts/geomanist/geomanist-regular-webfont.woff
// module chunks = main